<div adaptBlockingButtonGroup>
    @if (useBlockingClick) {
        <button [adaptButton]="saveButtonType"
                [disabled]="saveIsDisabled"
                [adaptBlockingClick]="onBlockingSaveClick"
                data-tour="standard-dialog-save-button"
                data-test="standard-dialog-save-button"></button>
    } @else {
        <button [adaptButton]="saveButtonType"
                [disabled]="saveIsDisabled"
                (click)="saveClick.emit()"
                data-tour="standard-dialog-save-button"
                data-test="standard-dialog-save-button"></button>
    }
    @if (!hideCancelButton) {
        <button #cancelButton
                [adaptButton]="cancelButtonType"
                (click)="onCancelClick()"
                data-tour="standard-dialog-cancel-button"
                data-test="standard-dialog-cancel-button"></button>
    }
</div>
